import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const RENTAL_METRICS = [
  {
    metricId: '10',
    displayName: 'Value based Gross Rental Yield',
    definition:
      'Is calculated based on the annualised rent (Median Asking Rent x 52 (weeks)), divided by the median value of those properties advertised for rent. <br /> <br /> <br /> <b>Unavailable geographies: Postcode</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '47',
    displayName: 'Change in Rental Rate (12 months)',
    definition:
      'The difference between the median weekly advertised rental rate in the current period compared to the same period 12 months ago. The result is expressed as a percentage.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '48',
    displayName: 'Change in Rental Rate (5 years)',
    definition:
      'The difference between the median weekly advertised rental rate in the current period compared to the same period 5 years ago. The result is expressed as a percentage.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '49',
    displayName: 'Median Asking Rent (12 months)',
    definition:
      'The middle value of advertised weekly rents captured by Cotality during the 12 month period.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '50',
    displayName: 'Rental Rate Observations (12 months)',
    definition:
      "The number of observations that have been used to calculate the 'Median Asking Rent' figure.",
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '77',
    displayName: 'Median Asking Rent (quarterly)',
    definition:
      'The middle value of weekly rents captured by NZ Government during the last quarter.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '78',
    displayName: 'Rental Rate Observations (quarterly)',
    definition:
      'The number of observations that have been used to calculate the Median Asking Rent figure.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '79',
    displayName: 'Change in Rental Rate (12 months)',
    definition:
      'The difference between the median rental rate in the current period compared to the same period 12 months ago. The result is expressed as a percentage.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '80',
    displayName: 'Value Based Gross Rental Yield',
    definition:
      'Is calculated based on the annualised rent (Median Asking Rent x 52 (weeks)), divided by the median value of properties within the geography.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
];

export const RentalMetrics = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Typography id="rental-metrics" variant="h6" fontWeight={600} my={0.5}>
        Rental Metrics
      </Typography>

      <Typography variant="body2">
        The Rental metrics provide statistics based off property's rental
        advertisement campaigns.
      </Typography>

      <br />

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ whiteSpace: 'nowrap' }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Display Name</TableCell>
              <TableCell>Definition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {RENTAL_METRICS.filter(metric =>
              country === 'au'
                ? metric.isAvailableInAU
                : metric.isAvailableInNZ,
            ).map(metric => (
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.metricId}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.displayName}
                </TableCell>
                <TableCell
                  dangerouslySetInnerHTML={{ __html: metric.definition }}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
